// Authors may edit or delete their idea, praise or direct feedback for this long after submitting it.
export const AUTHOR_EDIT_WINDOW_MS = 60 * 60 * 1000;

/** Milliseconds left in the author edit window — 0 once it has closed. */
export const editWindowRemainingMs = (createdAt: Date | string, now: number = Date.now()): number =>
  Math.max(0, new Date(createdAt).getTime() + AUTHOR_EDIT_WINDOW_MS - now);

export const isWithinEditWindow = (createdAt: Date | string, now: number = Date.now()): boolean =>
  editWindowRemainingMs(createdAt, now) > 0;
